import { ReadinessChip } from '../../components/atoms.js';
import { ClipTooltip } from '../../components/tooltip.js';
import type { TestCaseListItem } from '../../lib/catalog-api.js';
import { sourceLabelShort } from '../../lib/source-label.js';

// #144: Eine Testfallzeile des Prozessbaums — vorher dreifach kopiert (Prozessast, „Ohne
// Prozess", Suchtreffer). Das Quell-/Glied-Label steht GESTAPELT unter der TestFlow-ID: einzeilig
// („ETO-00015 · OTC_17 · 5/9") fraß es in der 380-px-Baumspalte den Platz des Titels, der auf zwei
// Wörter schrumpfte. Bei mehreren Ketten zeigt die Zeile nur die erste plus „ +N"; der volle Text
// steht im title-Attribut. Die Detailansicht bleibt einzeilig (dort ist Platz).
// `IdLabel` bleibt unangetastet — es wird an vielen anderen Stellen einzeilig benutzt.
export function TestCaseTreeRow({
  testCase: tc,
  title,
  selected,
  showSourceRef,
  onSelect,
}: {
  testCase: TestCaseListItem;
  title: string;
  selected: boolean;
  showSourceRef: boolean;
  onSelect: () => void;
}) {
  const label = showSourceRef ? sourceLabelShort(tc.source_ref, tc.chain_refs ?? []) : null;
  return (
    <ClipTooltip text={title} className="block w-full">
      <button
        type="button"
        onClick={onSelect}
        className={`flex w-full items-center gap-2 rounded-btn px-2 py-1 text-left text-sm ${
          selected
            ? 'bg-brand-accent/10 ring-1 ring-inset ring-brand-accent'
            : 'hover:bg-[var(--bg-subtle)]'
        }`}
      >
        <span className="flex shrink-0 flex-col leading-tight">
          <span className="font-mono text-brand-accent">{tc.human_id}</span>
          {label && (
            <span title={label.full} className="font-mono text-[10px] text-text-muted">
              {label.short}
            </span>
          )}
        </span>
        <span data-clip className="flex-1 line-clamp-2 text-text-body">
          {title}
        </span>
        <ReadinessChip value={tc.readiness} />
      </button>
    </ClipTooltip>
  );
}
